import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getLensData } from '../Components/NetworkHandler';

function LoadingPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    // Function called when data has been successfully loaded
    const onLoaded = (loadedData) => {
        console.log('Lens data loaded:', loadedData);

        // Broadcast an application-level event other parts of the app can listen for
        try {
            window.dispatchEvent(new CustomEvent('lensLoaded', { detail: loadedData }));
        } catch (e) {
            // ignore if event cannot be dispatched
        }

        // Optional: automatically navigate to camera-kit with decoded params if present
        if (loadedData && (loadedData.lensID || loadedData.lensGroup)) {
            const params = new URLSearchParams();
            if (loadedData.lensID) params.set('lensId', loadedData.lensID);
            if (loadedData.lensGroup) params.set('groupId', loadedData.lensGroup);
            console.log('Navigating to /camera-kit with params:', params.toString());
            // small delay so user can see the loaded state (remove if not desired)
            setTimeout(() => navigate(`/camera-kit?${params.toString()}`), 300);
        }
    };

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!id) {
                setError('Missing id in URL');
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                // TODO: replace with real API base URL and token or pass via env/URL
                const baseUrl = 'https://wild-surf-2b29.snowy-field-1db1.workers.dev/getLensInfo';
                const authToken = "6c97e073-cbfb-497d-90b7-1c2d527edbe7"; // optional global injection

                const result = await getLensData(baseUrl, id, authToken);
                if (!cancelled) {
                    setData(result);
                    // call the onLoaded hook
                    onLoaded(result);
                    setLoading(false);
                }
            } catch (err) {
                if (!cancelled) {
                    console.error('Error fetching lens data:', err);
                    setError(err.message || 'Request failed');
                    setLoading(false);
                }
            }
        };

        run();

        return () => { cancelled = true; };
    }, [id]);

    return (
        <div style={{ padding: 20 }}>
            {loading ? (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60vh'
                }}>
                    <div style={{ fontSize: 48, marginBottom: 10, animation: 'spin 1s linear infinite' }}>⭮</div>
                    <p>Loading…</p>
                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            ) : error ? (
                <div style={{ color: 'red' }}>
                    <p>Error: {error}</p>
                </div>
            ) : (
                <div>
                    <h3>Result</h3>
                    <pre style={{ background: '#f5f5f5', padding: 10 }}>{JSON.stringify(data, null, 2)}</pre>
                </div>
            )}
        </div>
    );
}

export default LoadingPage;